"use client";

import { useHydrateAtoms } from "jotai/utils";
import {
  trackedLemmaIdsAtom,
  trackedLemmasCountAtom,
} from "~/state/lemmas/state";

export function TrackedLemmasProvider({
  initialTrackedLemmaIds,
  initialTrackedLemmasCount,
  children,
}: {
  initialTrackedLemmaIds: number[];
  initialTrackedLemmasCount: number;
  children: React.ReactNode;
}) {
  useHydrateAtoms([
    [trackedLemmaIdsAtom, initialTrackedLemmaIds],
    [trackedLemmasCountAtom, initialTrackedLemmasCount],
  ]);

  return children;
}
